import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from '../../../core/dialogs/core-dialog.service';
import { CompaniesIntegrationsService } from '../companiesintegrations.service';
import { Office365Service } from '../office365.service';
import { IntegrationEditOffice365UserEditComponent } from './user-config/user-config.component';

@Component({
  selector: 'app-integration-edit-office365',
  templateUrl: './integration-edit-office365.component.html',
  styleUrls: ['./integration-edit-office365.component.scss']
})
export class IntegrationEditOffice365Component implements OnInit {

  public integration: any = {
    configuration: {}
  };

  public connected: boolean = false;
  public connectionInfo: any = {};

  constructor(
    private coreDialogService: CoreDialogService,
    private dialogService: DialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private companiesIntegrationsService: CompaniesIntegrationsService,
    private office365Service: Office365Service,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.companiesIntegrationsService.getByCode("office365").subscribe(
      data => {
        if (data != null) {
          if (data.configuration == null) data.configuration = {};
          this.integration = data;
          if (this.integration.configuration.authorization?.access_token != null) {
            this.connected = true;
            this.loadConnectionInfo();
          }
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  save() {
    this.companiesIntegrationsService.save(this.integration.id, this.integration).subscribe(
      data => {
        this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  connect() {
    this.office365Service.authorize(this.integration.id).subscribe(
      (data: any) => {
        if (data.success) {
          location.replace(data.url);
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }
  disconnect() {
    this.coreDialogService.confirm({
      message: '¿Quieres desconectar la integración de office 365?',
      accept: () => {
        this.connected = false;
        this.integration.configuration = {};
        this.save();
      },
      reject: () => {

      }
    });
  }

  loadConnectionInfo() {
    this.office365Service.me(this.integration.id).subscribe(
      (data: any) => {
        this.connectionInfo = data;
        this.loadOffice365Users();
      },
      error => {
        this.connected = false;
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  loadOffice365Users() {
    this.office365Service.users(this.integration.id).subscribe(
      (data: any) => {
        //actualizamos los users en configuracion
        if (data.value != null && data.value.length > 0) {
          if (this.integration.configuration.users == null) this.integration.configuration.users = [];
          data.value.forEach(o365User => {
            let currentUserConfig = this.integration.configuration.users.find(m => m.id == o365User.id);
            if (currentUserConfig == null) {
              //si no existe la calve en configuracion creamos opciones por defecto
              currentUserConfig = {
                id: o365User.id,
                displayName: o365User.displayName,
                userPrincipalName: o365User.userPrincipalName,
                contacts: { enabled: false },
                mail: { enabled: false },
                calendar: { enabled: false }
              };
              this.integration.configuration.users.push(currentUserConfig);
            } else {
              currentUserConfig.displayName = o365User.displayName;
              currentUserConfig.userPrincipalName = o365User.userPrincipalName;
            }
          });
        } else if (data.error != null) {
          //no hemos podido obtener los usuarios, no tenemos calro si por ser cuenta personal (hasta el 14/06/2023 funcionaba con msgraph, ahroa parece haber dejado de funcionar)
          //añadimos al usaurio principal en usuarios
          if (this.integration.configuration.users == null) this.integration.configuration.users = [];
          let currentUserConfig = this.integration.configuration.users.find(m => m.id == this.connectionInfo.id);
          if (currentUserConfig == null) {
            //si no existe la calve en configuracion creamos opciones por defecto
            currentUserConfig = {
              id: this.connectionInfo.id,
              displayName: this.connectionInfo.displayName,
              userPrincipalName: this.connectionInfo.userPrincipalName,
              contacts: { enabled: false },
              mail: { enabled: false },
              calendar: { enabled: false }
            };
            this.integration.configuration.users.push(currentUserConfig);
          } else {
            currentUserConfig.displayName = this.connectionInfo.displayName;
            currentUserConfig.userPrincipalName = this.connectionInfo.userPrincipalName;
          }
        }
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
      }
    );
  }

  configUser(o365User: any) {
    const ref = this.dialogService.open(IntegrationEditOffice365UserEditComponent, {
      header: "Configuración de usuario",
      width: '500px',
      data: {
        user: o365User
      }
    });
    ref.onClose.subscribe((data: any) => {
      if (data) {
        o365User.user_id = data.user_id;
        o365User.contacts = data.contacts;
        o365User.mail = data.mail;
        o365User.calendar = data.calendar;
      }
    });
  }
}
